export default __webpack_public_path__ + "static/CenterImg-f25b4ed4897637c13621ec6b4fb0f96d.png";